import React from "react";
import IconAdorner from "../../../components/icon/IconAdorner";
import { useTheme } from "../../../hooks";
import { isEmpty } from "../../../utils";
import Input, { InputProps } from "../input/Input";

const Search: React.FC<React.PropsWithChildren<InputProps>> = ({ value = "", disabled = false, ...rest }) => {
  const { Theme } = useTheme();

  const empty: boolean = isEmpty(value as string);
  return (
    <Input
      {...rest}
      value={value}
      clearable={!empty}
      endAdorner={
        empty ? (
          <IconAdorner
            iconName="fa-search"
            styles={{ color: Theme.placeholder.color, hoverColor: Theme.placeholder.color }}
            disabled={disabled}
          />
        ) : undefined
      }
    />
  );
};

export default Search;
